// initial state
const state = {
  link: '',
  enrollmentId: '',
  studentId: '',
  dateStart: '',
  dateEnd: '',
  timeStart: '',
  timeEnd: '',
  city: '',
  envelopeId: false,
}

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
const mutations = {

  updateLink(state, payload) {
    state.link = payload;
  },
  updateEnrollmentId(state, payload) {
    state.enrollmentId = payload;
  },
  updateStudentId(state, payload) {
    state.studentId = payload;
  },
  updateDateStart(state, payload) {
    state.dateStart = payload;
  },
  updateDateEnd(state, payload) {
    state.dateEnd = payload;
  },
  updateTimeStart(state, payload) {
    state.timeStart = payload;
  },
  updateTimeEnd(state, payload) {
    state.timeEnd = payload;
  },
  updateCity(state, payload) {
    state.city = payload;
  },
  updateEnvelopeId(state, payload){
    state.envelopeId = payload;
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
